import gql from 'graphql-tag';

const WDT_STUDENT_OVERALL_PROGRESS_QUERY = gql`
  query wdtOverallStudentProgressReport($where: WdtStudentOverallProgressReportWhereInput!) {
    wdtStudentOverallProgressReport(where: $where) {
      progress {
        module
        level
        charactersCompletedCount
      }
    }
  }
`;

export default WDT_STUDENT_OVERALL_PROGRESS_QUERY;
